<template>
    <div id="app">
      <link rel="stylesheet" 
        href="https://use.fontawesome.com/releases/v5.2.0/css/all.css" 
        integrity="sha384-hWVjflwFxL6sNzntih27bfxkr27PmbbK/iSvJ+a4+0owXq79v+lsFkW54bOGbiDQ" 
        crossorigin="anonymous">
        
      <div class="container">
       <div class="row" >
         <div class="col-xs-1 col-sm-1 col-lg-1">          
            <span style="display:inline-block; width: 100px;"></span>
            
            <component :is="currentMenu" :right="side === 'right' ? true: false" width="200">
                 <a href="#">
                    <i v-if="allowShowFlow" class="far fa-comments"></i>
                    <span v-if="allowShowFlow"><router-link to="/flow">代購流程和疑問</router-link></span>
                </a>
                <a href="#">
                    <i v-if="allowShowContact" class="far fa-envelope"></i>
                    <span v-if="allowShowContact"><router-link to="/contact">代購訂單</router-link></span>
                </a> 
                <a href="#" v-show="allowShowVediolist">
                    <i v-show="allowShowVediolist" class="fas fa-search-plus"></i>
                    <span v-show="allowShowVediolist"><router-link to="/viewlistvedio">Vedio List</router-link></span>
                    <!--old one is /vediolist -->
                </a>    
                <a href="#" v-show="allowShowVediolist">
                    <i v-show="allowShowVediolist" class="fa fa-cloud-upload-alt"></i>
                    <span v-show="allowShowVediolist"><router-link to="/upload">Upload Image/File</router-link></span>
                </a>  
                 <a href="#" v-if="allowShowProduct">
                    <i class="fa fa-gift"></i>
                    <!--<span ><router-link to="/product">保健食品</router-link></span>-->
                    <span><router-link :to="{ name: 'Product', params: { category: 'vit' } }">保健食品</router-link></span>
                </a>
                <a href="#" v-if="allowShowProduct">
                    <i class="fa fa-gift"></i>
                    <!--<span ><router-link to="/product">美容用品</router-link></span>-->
                    <span><router-link :to="{ name: 'Productbeauty', params: { category: 'beauty' } }">美容用品</router-link></span>
                </a>
                <a href="#">
                    <i class="fab fa-reddit-alien"></i>
                    <span><router-link to="/Newshome">新聞資訊</router-link></span>
                </a> 
                <a href="#">
                    <i class="fas fa-home"></i>
                    <span><router-link to="/home">主頁</router-link></span>
                </a> 
                <a href="#">
                    <i v-if="allowShowAussie" class="fa fa-eye"></i>
                    <span v-if="allowShowAussie"><router-link to="/sydney">Sydney</router-link></span>
                </a>
                <a href="#">
                    <i v-if="allowShowAussie" class="fa fa-eye"></i>
                    <span v-if="allowShowAussie"><router-link to="/melbourne">Melbourne</router-link></span>
                </a>

            </component>
          </div>
    <!--      <div class="col-xs-2 col-sm-1 col-lg-1" align="left">
              <a href="https://www.wewamart.com/"> 
                 <img id="logo" src="@/assets/logo.png" alt=""/>
               </a>
          </div>-->
          <div class="col-xs-4 col-sm-11 col-lg-11" align="right">
              <div style="height:100%; position:relative;">
                  <a><signinlogin></signinlogin></a> 
              </div>
          </div>

      </div>     
      
      <div class="row" style="height:82%;">
          <router-view/>
       </div>

        
                     
<!--
          <div class="row">
              <div class="column left" >
                <div class="row text-centre">
                  <div class="col-xs-1 text-dark font-italic">
                    <figure>
                      <figcaption>Sydney it's </figcaption>
                      <span>{{ setTime() }}</span>
                      <br><br>
                      <button @click='logout'>Logout</button>
                    </figure>
                  </div>
                </div>
              </div>
              <div class="column right">
                  <router-view/>
              </div>
          </div>
  -->        
          

       

   </div>  
  </div>
</template>

<script>
    import slide from './components/Menu/slide';
    import bubble from './components/Menu/bubble';
    import elastic from './components/Menu/elastic';
    import falldown from './components/Menu/fallDown';
    import push from './components/Menu/push';
    import pushrotate from './components/Menu/pushRotate';
    import reveal from './components/Menu/reveal';
    import scaledown from './components/Menu/scaleDown';
    import scalerotate from './components/Menu/scaleRotate';
    import stack from './components/Menu/stack';
    import Menu from './components/Menu';
    import Movie from './components/movie';
    import Home from './components/home';
    import Contact from './components/contact';
    import Review from './components/review';
    import Login from './components/login';
    import SignUp from './components/signup';
    import Apartment from './components/apartment';
    import Melbourne from './components/melbourne';
    import Sydney from './components/sydney';
    import firebase from 'firebase';
    import Vedio from './components/vedio';
    import Upload from './components/upload';
    import Signinlogin from './components/signinlogin';
    import Product from './components/product';
    import Editproductitem from './components/editproductitem';
    import Viewlistproduct from './components/viewlistproduct';
    import Flow from './components/flow';
    import Newshome from './components/newshome';
    import PicZoom from './components/PicZoom';
    import Cartitem from './components/cartitem';

    export default {
      data() {
        return {
          menus: {
            slide: { buttonText: 'Slide' },
            push: { buttonText: 'Push' },
            pushRotate: { buttonText: 'Push Rotate' },
            reveal: { buttonText: 'Reveal' },
            scaleDown: { buttonText: 'Scale Down' },
            scaleRotate: { buttonText: 'Scale Rotate' }
            // elastic: { buttonText: 'Elastic - (WIP)' },
            // stack: { buttonText: 'Stack - (WIP)' },
            // bubble: { buttonText: 'Bubble - (WIP)' },
            // fallDown: { buttonText: 'Fall Down - (WIP)' }
          },
          side: 'left',
          currentMenu: 'slide',
          allowShowAussie: false,
          allowLogin:true,
          allowShowHome: true,
          allowShowTime:false,
          allowShowContact: true,
          allowShowReview: true,
          allowShowVediolist: false,
          allowShowUpload: false,
          allowShowProduct: true,
          allowShowFlow: true
        };
      },
      components: {
        slide,
        bubble,
        elastic,
        push,
        pushrotate,
        scaledown,
        scalerotate,
        reveal,
        stack,
        falldown,
        Menu,
        Movie,
        Home,
        Contact,
        Review,
        Login,
        Apartment,
        Vedio,
        'signinlogin' : Signinlogin,
        'product' : Product,
        'editproductitem' : Editproductitem,
        'viewlistproduct' : Viewlistproduct,
        Cartitem
      },
      methods: {
        changeMenu(menu) {
          this.currentMenu = menu.replace(/ +/g, '').toLowerCase();
          return this.currentMenu;
        },
        changeSide(side) {
          this.side = side;
        },
        setTime: function() {
          var timeAtLoad = (new Date());/*this.time;*/
          return timeAtLoad.toLocaleTimeString([], {timeZone: 'Australia/Sydney', hour: '2-digit', minute:'2-digit', hour12: true})
        },
        logout: function() {
          firebase.auth().signOut().then(() =>{
            this.$router.replace('login')
          })
        }
      }
    };
</script>

 <style lang="less">
    *,
    *:after,
    *:before {
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
    }

    /* Single-direction drop shadow */
    hr.separator {
      border: 1px;
      padding: 1px;
      box-shadow: 0px 0px 8px 1px #ffffff;
      width: 85%;
    }

   .img-box{
        width: 30px;
        font-size:2px;
        line-height: 10px;
    }
    .img-box img{
        display: block;
    }
    
    html {
      height: 100%;
    }

    body {
      height: 100%;
      color: #fffce1;
      font-family: 'Raleway', Arial, sans-serif;
      margin: 0px;
    }

    #app {
      height: 100%;
    }

    a {
      color: #4e4a46;
      text-decoration: none;

      &:hover,
      &:focus {
        color: #c94e50;
      }
    }

    main {
      height: 100%;
      padding: 3em 2em;
      text-align: center;
      background: #b4bad2;
      overflow: auto;
    }

    h1 {
      font-weight: 800;
      font-size: 3.75em;
    }

    .description {
      max-width: 20em;
      margin: 1.2em auto 1em;
      line-height: 1.3em;
      font-weight: 400;
    }

    .demo-buttons {
      font-size: 1em;
      max-width: 1200px;
      margin: 2em auto 3em;
      padding: 0 10em;

      a {
        display: inline-block;
        margin: 0.75em;
        padding: 1.35em 1.1em;
        width: 15em;
        background: #fffce1;
        text-transform: uppercase;
        letter-spacing: 1px;
        font-weight: 800;
        border-top-left-radius: 20px 50px;
        border-top-right-radius: 20px 50px;
        border-bottom-right-radius: 20px 50px;
        border-bottom-left-radius: 20px 50px;
        cursor: pointer;

        &.currentDemo {
          background: #c94e50;
          color: #fffce1;
        }
      }
    }

    .sideButton {
      display: inline-block;
      width: 5em;
      height: 2.5em;
      line-height: 2.5em;
      cursor: pointer;
      background: #fffce1;
      text-transform: uppercase;
      letter-spacing: 1px;
      font-size: 0.8em;
      font-weight: 800;

      &.left {
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
      }

      &.right {
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
      }

      &.active {
        background: #c94e50;
        color: #fffce1;
      }
    }

    @media screen and (max-width: 40em) {
      main {
        font-size: 80%;
      }

      h1 {
        padding-top: 1em;
        font-size: 2.5em;
      }

      .demo-buttons {
        max-width: 900px;
        padding: 0 2em;
      }
    }

    //
    // Burger menu custom styles
    //
    .bm-burger-button {
      position: absolute;
      width: 23px;
      height: 18px;
      left: 25px;
      top: 12px;
    }

    .right .bm-burger-button {
      left: initial;
      right: 36px;
    }

    .bm-burger-bars {
      background: #373a47;
    }

    .bm-morph-shape {
      fill: #373a47;
    }

    .bm-menu {
      background: #373a47;

      a {
        color: #ffffff; /*18-dec b8b7ad*/

        &:hover,
        &:focus {
          color: #c94e50;
        }
      }
    }

    //
    // Mixins
    //
    .menu-1 {
      .bm-cross {
        background: #bdc3c7;
      }

      .bm-menu {
        padding: 2.5em 1.5em 0;
        font-size: 1.15em;
      }
    }

    .menu-2 {
      .bm-cross {
        background: #999;
      }

      .bm-menu {
        padding: 3.4em 1em 0;
      }

      a {
        padding: 1em;
      }

      i {
        font-size: 1.7em;
        vertical-align: middle;
        color: #282a35;
      }
    }

    .menu-3 {
      .bm-cross {
        background: #888;
      }

      .bm-menu {
        padding: 2em 1em;
        font-size: 1.15em;
      }

      i {
        opacity: 0.5;
      }

      span {
        text-transform: uppercase;
        letter-spacing: 1px;
        font-size: 0.75em;
      }
    }

    .menu-4 {
      .bm-cross {
        background: #888;
      }

      h2 {
        margin: 0 auto;
        padding: 2em 1em;
        color: rgba(0, 0, 0, 0.4);
        box-shadow: inset 0 -1px rgba(0, 0, 0, 0.2);

        i {
          margin-left: 0.2em;
        }

        span {
          font-size: 1.6em;
          font-weight: 700;
        }
      }

      a {
        padding: 1em;
        text-transform: uppercase;
        transition: background 0.3s, box-shadow 0.3s;
        box-shadow: inset 0 -1px rgba(0, 0, 0, 0.2);

        span {
          letter-spacing: 1px;
          font-weight: 400;
        }

        &:hover,
        &:focus {
          background: rgba(0, 0, 0, 0.2);
          box-shadow: inset 0 -1px rgba(0, 0, 0, 0);
          color: #b8b7ad;
        }
      }
    }

    //Login 

    //For unequal columns
    /* Create two unequal columns that floats next to each other */
    .column {
        float: left;
        padding: 10px;
        
    }

    .left {
      width: 12%;
    }

    .right {
      width: 88%;
    }

    /* Clear floats after the columns */
    .row:after {
        content: "";
        display: table;
        clear: both;
    }

    // end

    .bg-primary {
    background-color: #1a52c6;
   }

   // For Logout Button
   .logout {
      background:url('https://dh3vbjnk0bnfa.cloudfront.net/static/centralauth/images/btn-login-hover.png') no-repeat 5px 5px #484B4F;
        width: 100px;
        cursor:pointer;
        border-radius:50px;
        padding:10px 20px 10px 0;
        color:White;
        font-size:14px;
        text-align:left;
        text-indent:40px;
        display:block;
        margin:0 auto;
 
    /* Animations: */
    -webkit-transition-timing-function: ease-in-out;
    -webkit-transition-duration: .4s;
    -webkit-transition-property: all;
  
    -moz-transition-timing-function: ease-in-out;
    -moz-transition-duration: .4s;
    -moz-transition-property: all;
  }

  .logout:hover {
    background-image: url( 'https://dh3vbjnk0bnfa.cloudfront.net/static/centralauth/images/btn-login.png' );
    background-position: 65px 5px;
    text-indent: 15px;  
  }

</style>



// WEBPACK FOOTER //
// src/App.vue